import parsePhoneNumberFromString from 'libphonenumber-js'

/** Telefone brasileiro válido (com DDD; o +55 é acrescentado quando falta). Regra dos formulários de cliente. */
export const isValidPhoneNumber = (number: string): boolean => {
    const phoneNumber = parsePhoneNumberFromString(number.startsWith('+55') ? number : `+55${number}`)
    return phoneNumber?.isValid() || false
}
